import { fail } from "assert";
import { getAllNbiKpis } from "./helper";
import { getAllKpis } from "../../../cpr-salescredit-interactive-chart/utils/helper";
import { NBIKpis } from "../../generic/generic-nbi-domains";
import { SCKpis } from "../../generic/generic-sc-domain";

export function BuildDateFilter(
  selectedDate: Date,
  kpi: string,
  attributesHaveTime = false
): string {
  const currentDate = selectedDate;
  let finalDate = "";

  const currentYear: number = currentDate.getFullYear();

  const dates: number[] = [currentYear];
  let separator = ":";
  if (!attributesHaveTime) {
    dates.push(currentDate.getFullYear() - 1);
    separator = "+";
  }
  const yearMinus2 = currentDate.getFullYear() - 2;

  dates.unshift(yearMinus2);
  const nbiKpis = new NBIKpis();

  if (kpi === SCKpis.SC_MARKUP || kpi === nbiKpis.NBI_FY) {
    const today = new Date();
    for (const date of dates) {
      if (date === today.getFullYear()) {
        finalDate += new Date(
          Date.UTC(
            selectedDate.getFullYear(),
            GetMonth(
              attributesHaveTime,
              date,
              currentYear,
              yearMinus2,
              selectedDate.getMonth(),
              kpi
            ),
            GetDayOfMonth(
              attributesHaveTime,
              date,
              currentYear,
              yearMinus2,
              selectedDate.getDate(),
              kpi
            )
          )
        )
          .toISOString()
          .slice(0, 10);
      } else {
        finalDate += new Date(
          Date.UTC(
            date,
            GetMonth(
              attributesHaveTime,
              date,
              currentYear,
              yearMinus2,
              11,
              kpi
            ),
            GetDayOfMonth(
              attributesHaveTime,
              date,
              currentYear,
              yearMinus2,
              31,
              kpi
            )
          )
        )
          .toISOString()
          .slice(0, 10);
      }
      finalDate += separator;
    }
  } else {
    for (const date of dates) {
      const month = GetMonth(
        attributesHaveTime,
        date,
        currentYear,
        yearMinus2,
        currentDate.getMonth(),
        kpi
      );
      const dayOfMonth = GetDayOfMonth(
        attributesHaveTime,
        date,
        currentYear,
        yearMinus2,
        currentDate.getDate(),
        kpi
      );

      const toDate = new Date(Date.UTC(date, month, dayOfMonth));
      finalDate += toDate.toISOString().slice(0, 10);
      finalDate += separator;
    }
  }
  finalDate = finalDate.substring(0, finalDate.lastIndexOf(separator));
  return finalDate;
}
function GetDayOfMonth(
  attributesHaveTime: boolean,
  date: number,
  currentYear: number,
  yearMinus2: number,
  currentDateDay: number,
  kpi: string
) {
  const firstDayOfMonth = 1;
  const lastDayOfDec = 31;

  if (attributesHaveTime === true) {
    return date === yearMinus2
      ? firstDayOfMonth
      : date === currentYear && !checkAsofKpi(kpi)
      ? lastDayOfDec
      : currentDateDay;
  } else {
    return currentDateDay;
  }
}

function GetMonth(
  attributesHaveTime: boolean,
  date: number,
  currentYear: number,
  yearMinus2: number,
  month: number,
  kpi: string
) {
  const janMonth = 0;
  const decemberMonth = 11;

  if (attributesHaveTime === true) {
    return date === yearMinus2
      ? janMonth
      : date === currentYear && !checkAsofKpi(kpi)
      ? decemberMonth
      : month;
  } else {
    return month;
  }
}

function checkAsofKpi(kpi: string) {
  const nbiAndScKpiList = getAllNbiKpis().concat(getAllKpis());
  const kpiList: string[] = nbiAndScKpiList.map(x => x.name);
  return kpiList.indexOf(kpi) !== -1;
}
